<template>
    <div :class="pageClass">
        <div class="page_top" v-show="!isDetails">
            <div class="title" @click="goHome()"><i class="icon"></i>搜尋物件</div>
            <div class="search_type">
                <div class="item" :class="{'is-active': qkSearch}" @click="changeSearchType(true)">快速搜尋</div>
                <div class="item" :class="{'is-active': !qkSearch}" @click="changeSearchType(false)">進階搜尋</div>
            </div>
            <div class="search_bar">
                <template v-if="qkSearch">
                    <div class="qk">
                        <div class="item" :class="qkArea === 'a' ? 'is-active': ''" @click="searchQK('a')">全部</div>
                        <div class="item" :class="qkArea === 'n' ? 'is-active': ''" @click="searchQK('n')">北部</div>
                        <div class="item" :class="qkArea === 'c' ? 'is-active': ''" @click="searchQK('c')">中部</div>
                        <div class="item" :class="qkArea === 's' ? 'is-active': ''" @click="searchQK('s')">南部</div>
                        <div class="item" :class="qkArea === 'e' ? 'is-active': ''" @click="searchQK('e')">東部</div>
                    </div>
                </template>
                <template v-else>
                    <div class="mo">
                        <div class="item" :class="subSelect === 'type' ? 'is-active': ''" @click="changeSelect('type')">
                            種類
                        </div>
                        <div class="item" :class="subSelect === 'area' ? 'is-active': ''" @click="changeSelect('area')">
                            地區
                        </div>
                        <div class="item" :class="subSelect === 'pay' ? 'is-active': ''" @click="changeSelect('pay')">
                            金額
                        </div>
                        <div class="order_by" @click="changeSelect('order')"></div>
                    </div>
                    <div class="mo_select" v-if="subSelect">
                        <template v-if="subSelect === 'type'">
                            <div class="tit">種類</div>
                            <el-select class="select_area" popper-class="select_area_popper" v-model="form.sellType"
                                       @change="handleSearch">
                                <el-option label="全部" value=""></el-option>
                                <el-option v-for="({id, name},idx) in sellType" :label="name" :value="id" :key="idx"/>
                            </el-select>
                        </template>
                        <template v-if="subSelect === 'area'">
                            <div class="tit">選擇城市</div>
                            <div class="select_clear">
                                <i class="el-icon-error icon" v-if="form.area.length" @click="form.area = []"></i>
                                <el-select class="select_area" popper-class="select_area_popper" multiple
                                           v-model="form.area" placeholder="請選擇">
                                    <el-option v-for="({areaId, areaName},idx) in searchArea" :label="areaName"
                                               :value="areaId" :key="idx"/>
                                </el-select>
                            </div>
                            <div class="btn">
                                <el-button type="success" :disabled="loading" @click="handleSearch()"><i
                                    class="el-icon-loading" v-if="loading"></i>送出
                                </el-button>
                            </div>
                        </template>
                        <template v-if="subSelect === 'pay'">
                            <div class="select_flex">
                                <div class="item">
                                    <div class="tit">最低</div>
                                    <el-input type="number" clearable v-model="form.amountFrom"
                                              placeholder="不限"></el-input>
                                </div>
                                <div class="item">
                                    <div class="tit">最高</div>
                                    <el-input type="number" clearable v-model="form.amountTo"
                                              placeholder="不限"></el-input>
                                </div>
                            </div>
                            <div class="btn">
                                <el-button type="success" :disabled="loading" @click="handleSearch()"><i
                                    class="el-icon-loading" v-if="loading"></i>送出
                                </el-button>
                            </div>
                        </template>
                        <template>
                            <ul class="orderby_list" v-if="subSelect === 'order'">
                                <li class="item" :class="form.orderByCreateAt === '' ? 'is-active': ''"
                                    @click="changeOrderBy('')">未選擇排序
                                </li>
                                <li class="item" :class="form.orderByCreateAt === 'desc' ? 'is-active': ''"
                                    @click="changeOrderBy('desc')">時間新到舊
                                </li>
                                <li class="item" :class="form.orderByCreateAt === 'asc' ? 'is-active': ''"
                                    @click="changeOrderBy('asc')">時間舊到新
                                </li>
                            </ul>
                        </template>
                    </div>
                </template>
            </div>
        </div>
        <div class="page_padding" :class="{'page_loading': listLoading}" v-infinite-scroll="scrollLoad"
             infinite-scroll-immediate="false">
            <div class="cate" v-show="!isDetails">
                <!-- <div class="search_type" @click="changeSearchType()">{{qkSearch ? '進階搜尋' : '快速搜尋'}}</div> -->
                <div class="item" :class="searchType === 'all' ? 'is-active': ''" @click="changeTag('all')">物件買賣</div>
                <div class="item" :class="searchType === 'my' ? 'is-active': ''" @click="changeTag('my')">我的刊登</div>
            </div>
            <template v-if="isDetails">
                <router-view/>
            </template>
            <ul class="list" v-else>
                <template v-if="listLoading">
                    <div class="loading">
                        <i class="el-icon-loading"></i>
                    </div>
                </template>
                <template v-else>
                    <template v-if="(sellList || {}).length > 0">
                        <div v-for="({id, saleType, area, amount, createdAt,updatedAt ,title, image},idx) in pageData"
                             :key="idx">
                            <li class="item"  style="position:relative;">
                                <div @click="handleDetail(id)">
                                    <div class="list_img">
                                        <p v-if="image" class="img" :style="`background-image: url(${image})`"></p>
                                        <div class="no_img" v-else>
                                            <p><img src="~@/assets/no_img.svg"></p>
                                            <p class="p_t_05">暫時沒有照片</p>
                                        </div>
                                    </div>
                                    <div class="flex space_between">
                                        <p class="tit">[{{saleType}}]</p>
                                        <p class="time">{{updatedAt  | moment("YYYY/MM/DD")}}</p>
                                    </div>
                                    <p class="tit">{{title}}</p>
                                    <p class="info">
                                        <span class="area">{{area}}</span>
                                        <span class="pay">{{amount ? formatNumber(amount) : '價格面議'}}</span>
                                    </p>
                                </div>
                                <div class="renew_button" v-if="searchType=='my' && checkArticleRenewDate(updatedAt)" style="position: absolute;top: 12px;right: 11px">
                                    <el-button type="warning" @click="renewArticle(id)">更新排序</el-button>
                                </div>
                            </li>
                            <InFeedAdsense
                                v-if="idx%4==0 && idx!=0"
                                data-ad-layout-key="-fb+5w+4e-db+86"
                                data-ad-client="ca-pub-9879330354493543"
                                data-ad-slot="5365863390">
                            </InFeedAdsense>
                        </div>

                        <div class="more_loading" v-if="moreLoading"><i class="el-icon-loading"></i></div>
                    </template>
                    <template v-else>
                        <template v-if="!pageState">
                            <li class="no_mydata">
                                <p class="txt">連線失敗，請稍後再試</p>
                                <p>
                                    <el-button type="success" :disabled="loading" @click="addPage">重試</el-button>
                                </p>
                            </li>
                        </template>
                        <template v-else>
                            <li v-if="isMyTagData" class="no_mydata">
                                <p class="tit">暫無刊登</p>
                                <p class="txt">目前沒有刊登，請前往刊登</p>
                                <p>
                                    <el-button type="success" :disabled="loading" @click="addPage">我要刊登</el-button>
                                </p>
                            </li>
                            <li v-else class="no_data">目前尚無任何資料</li>
                        </template>
                    </template>
                </template>
            </ul>
        </div>
        <div class="add_btn" @click="addPage" v-if="!isDetails && !isMyTagData"></div>
        <MENU v-if="!isDetails"/>
        <el-backtop target=".list_page .page_padding" v-if="!isDetails" :visibility-height="500" :bottom="150"
                    :right="25"/>
    </div>
</template>
<script>
    import FN from '@/components/fn'
    import {mapActions, mapGetters} from 'vuex'
    import MENU from '@/components/menu.vue'
    import _ from 'lodash'
    import ArticleService from '@/components/servicies/ArticleService.vue'
    import moment from 'moment/min/moment-with-locales'

    export default {
        name: 'sell',
        components: {
            MENU
        },
        mixins: [FN,ArticleService],
        data() {
            return {
                dialogVisible: false,
                qkSearch: true,
                qkArea: '',
                subSelect: '',
                searchType: 'all',
                pageTag: '',
                pageCount: 1, //實際頁數
                pageNum: 1, //打時計算
                allData: [],
                apiKey: {
                    'all': 'SELL_LIST',
                    'my': 'SELL_MYLIST'
                },
                form: {
                    area: [],
                    amountFrom: '',
                    amountTo: '',
                    orderByCreateAt: '',
                    saleType: '',
                    pageLimit: 15
                },
                renewData: {
                    articleId: "",
                    articleType: 3,
                }
            }
        },
        mounted() {
            //取得求職徵才分類
            this.getSearchType()
            //取得地區
            this.getArea()
            //取得求職徵才列表
            this.handleSearch()
        },
        computed: {
            ...mapGetters([
                'sellType',
                'searchArea',
                'sellList',
                'pages',
                'pageState'
            ]),
            isDetailsPage() {
                return this.$route.name === 'SellAdd' || this.$route.name === 'SellEdit'
            },
            isDetails() {
                const details = this.$route.name !== 'Sell'
                return details
            },
            pageClass() {
                let className = 'list_page '
                if (this.isDetailsPage) {
                    className += 'page '
                }
                if (this.isDetails) {
                    className += 'page_detail gray_bg'
                } else {
                    className += 'page_list'
                }
                return className
            },
            isMyTagData() {
                return this.searchType === 'my' && !this.sellList?.length
            },
            pageData() {
                this.sellList.forEach((item) => {
                    this.allData.push(item)
                })
                return this.allData
            }
        },
        methods: {
            ...mapActions([
                'FETCH'
            ]),
            getSearchType() {
                this.FETCH({
                    key: 'SELL_TYPE'
                })
            },
            getArea() {
                this.FETCH({
                    key: 'SEARCH_AREA'
                })
            },
            changeSelect(val) {
                if (this.subSelect === val) {
                    this.subSelect = ''
                } else {
                    this.subSelect = val
                }
            },
            changeSearchType(val) {
                this.clearSearchData() //清除進階搜尋資料
                this.qkSearch = val
            },
            searchQK(val) {
                this.clearSearchData() //清除進階搜尋資料
                this.qkArea = val
                const areaList = {
                    'a': [],
                    'n': [2, 3, 4, 5, 6],
                    'c': [7, 8, 9, 10, 11],
                    's': [12, 13, 14, 15],
                    'e': [16, 17, 18]
                }
                this.form.area = areaList[val]
                this.handleSearch()
            },
            handleSearch(limit) {
                if (!limit) {
                    this.listLoading = true
                }
                this.subSelect = ''
                this.searchType = this.$route.params.tag
                this.FETCH({
                    key: this.apiKey[this.searchType],
                    ...this.form,
                    page: limit || this.form.page,
                    pageLimit: this.form.pageLimit
                })
                    .then((res) => {
                        this.listLoading = false
                        this.moreLoading = false
                        //需要accToken的驗證
                        if (+(res || {}).code === -3) {
                            this.checkNewToken(this.handleSearch)
                        }
                        if (+(res || {}).code === -1) {
                            this.$message.error('連線失敗，請稍後再試或聯繫客服');
                        }
                        if (!+(res || {}).code) {
                            this.pageCount = this.pages?.current_page
                            //如果是第一頁記得要消除暫存區並捲動到最上方
                            if (this.pages?.current_page === 1) {
                                this.clearListData()
                            }
                            if (+this.pageCount === 1) {
                                this.moreLoading = false
                                setTimeout(() => {
                                    this.listLoading = false
                                }, 1000);
                            } else {
                                this.listLoading = false
                                setTimeout(() => {
                                    this.moreLoading = false
                                }, 1000);
                            }
                        }
                    })
                    .catch(() => {
                        this.listLoading = false
                        this.moreLoading = false
                        this.pageCount = this.pages?.current_page
                    })
            },
            changeOrderBy(val) {
                this.form.orderByCreateAt = val
                this.handleSearch()
            },
            addPage() {
                this.$router.push({name: 'SellAdd'})
            },
            changeTag(tagVal) {
                this.$router.push({
                    params: {tag: tagVal}
                })
                //this.searchList(tagVal)
                this.handleSearch()
            },
            handleDetail(id) {
                this.$router.push({name: 'SellDetails', params: {id: id}})
            },
            //滾動加載分頁
            scrollLoad: _.throttle(function () {
                const lastPage = this.pages.last_page
                const nowPage = this.pages.current_page
                if (lastPage > nowPage) {
                    this.moreLoading = true
                    this.pageCount++
                    this.handleSearch(this.pageCount)
                }
            }, 2000),
            //清除搜尋資料
            clearSearchData() {
                this.qkArea = ''
                this.form.area = []
                this.form.amountFrom = ''
                this.form.amountTo = ''
                this.form.orderByCreateAt = ''
                this.form.saleType = ''
            },
            //清除資料
            clearListData() {
                document.querySelector(".list_page .page_padding").scrollTop = 0
                this.allData = []
            },
            formatNumber(num) {
                if (num > 9999) {
                    num = num / 10000 + ' 萬'
                }
                return `NT $ ${num}`
            }
        },
        beforeUpdate() {
            localStorage.setItem('saleDateTime', moment().format('YYYY-MM-DD HH:mm:ss'));
        }
    }
</script>
